/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Phoneverified_Yes1Inputs */

const he_profile_phoneverified_yes1 = /** @type {(inputs: Profile_Phoneverified_Yes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מספר הטלפון אומת`)
};

const en_profile_phoneverified_yes1 = /** @type {(inputs: Profile_Phoneverified_Yes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone verified`)
};

/**
* | output |
* | --- |
* | "Phone verified" |
*
* @param {Profile_Phoneverified_Yes1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const profile_phoneverified_yes1 = /** @type {((inputs?: Profile_Phoneverified_Yes1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Phoneverified_Yes1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_phoneverified_yes1(inputs)
	return en_profile_phoneverified_yes1(inputs)
});
export { profile_phoneverified_yes1 as "profile_phoneVerified_yes" }